export default "__VITE_ASSET__53f4882e__"